import { BadgeCheck, Star, Zap, MessageSquare, Gem } from "lucide-react";

const ICONS = { check: BadgeCheck, star: Star, zap: Zap, message: MessageSquare, diamond: Gem };

export const BadgeChip = ({ badge, size = "sm" }) => {
  if (!badge) return null;
  const Icon = ICONS[badge.icon] || BadgeCheck;
  const big = size === "md";
  return (
    <span data-testid={`badge-${badge.key}`}
      className={`inline-flex items-center gap-1 rounded-full font-semibold border ${
        badge.key === "verified"
          ? "bg-foreground text-white border-foreground"
          : "bg-accent/10 text-accent border-accent/30"
      } ${big ? "text-xs px-2.5 py-1" : "text-[10px] px-2 py-0.5"}`}>
      <Icon className={big ? "w-3.5 h-3.5" : "w-3 h-3"} aria-hidden="true" />
      {badge.name}
    </span>
  );
};

export const BadgeList = ({ badges, max = 3, size = "sm" }) => {
  if (!badges?.length) return null;
  return (
    <span className="inline-flex flex-wrap gap-1.5 items-center">
      {badges.slice(0, max).map((b) => <BadgeChip key={b.key} badge={b} size={size} />)}
    </span>
  );
};
